import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import UpCustomerSettingsInfoComponent from '../UpCustomerSettingsInfoComponent';
import LoadingSpinner from '../LoadingSpinner';

import { Headline, Wrapper, Container, Anchor } from './styles';

const UpCustomerSettingsContainer = ({
  loading,
  anchorId,
  active = true,
  headline,
  explanation,
  example,
  recommendation,
  storageKey,
  margin,
  children,
}) => {
  const firstUpdate = useRef(true);
  const shouldScroll = useRef(true);
  const location = useLocation();

  useEffect(() => {
    // Use the first update to avoid scolling
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (!loading && shouldScroll.current) {
      const hash = location.hash.replace('#', '');
      if (hash) {
        const node = document.getElementById(hash);
        if (node) {
          node.scrollIntoView({ behavior: 'smooth' });
        }
      }
      // only do this on first render and don't do it if site is already loaded and just updated because of a save button click and fetching data again
      shouldScroll.current = false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const anchorNode = anchorId && <Anchor id={anchorId} />;

  const contentNode = loading ? <LoadingSpinner /> : children;

  return (
    <Wrapper margin={margin}>
      {anchorNode}
      <Headline active={active}>{headline}</Headline>
      <Container>
        <UpCustomerSettingsInfoComponent
          storageKey={storageKey}
          content={{
            explanation,
            example,
            recommendation,
          }}
        />
        {contentNode}
      </Container>
    </Wrapper>
  );
};

UpCustomerSettingsContainer.propTypes = {
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  explanation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  example: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  recommendation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  loading: PropTypes.bool,
  active: PropTypes.bool,
  storageKey: PropTypes.string,
  margin: PropTypes.string,
  anchorId: PropTypes.string,
};

export default UpCustomerSettingsContainer;
